import React, { useEffect,useState } from "react";
import axios from "axios";
import Chart from "react-apexcharts";
import { Box, Typography, Select, MenuItem } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
// import { fetchStockDashboardData } from "../../../redux/slices/stockDashboardSlice";
import { fetchStockDashboardData } from "../../../../redux/reducers/stockDashboardSlice";
const StockDashboard = () => {
  const dispatch = useDispatch();
  const { stockLevel, fastMovingProductName, loading } = useSelector((state) => state.stockDashboard);
  const [selectedYear, setSelectedYear] = useState("2025");
  const [stockLevelData, setStockLevelData] = useState([]);
  const [fastMovingData, setFastMovingData] = useState([]);

  useEffect(() => {
    dispatch(fetchStockDashboardData());
  }, [dispatch]);

  useEffect(() => {
    if (!stockLevel || !Array.isArray(stockLevel)) return;

    // LEFT: Stock Level Data
    const validStock = stockLevel.filter((item) => item.category);
    setStockLevelData(validStock);

    // RIGHT: Fast Moving Product based on selected year
    const yearData = fastMovingProductName[selectedYear] || [];
    setFastMovingData(yearData);
  }, [stockLevel, fastMovingProductName, selectedYear]);

  // Handler for year change
  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
  };

  // Chart Options - Vertical Bar Chart (Stock Level)
  const barChartOptions = {
    chart: { type: "bar", toolbar: { show: false } },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "40%",
        borderRadius: 4,
      },
    },
    dataLabels: { enabled: false },
    xaxis: {
      categories: stockLevelData.map((item) => item.category),
      labels: {
        style: { fontSize: '14px', colors: '#2C2C49' },
        rotate: 0,
      },
    },
    yaxis: {
      labels: {
        formatter: (val) => val.toLocaleString(),
      },
    },
    grid: { strokeDashArray: 4 },
    colors: ["#0047AB"],
  };

  const barChartSeries = [
    {
      name: "Stock",
      data: stockLevelData.map((item) => item.stockLevel),
    },
  ];

  // Chart Options - Horizontal Bar Chart (Fast Moving)
  const horizontalChartOptions = {
    chart: { type: "bar", toolbar: { show: false } },
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: '20%',
        borderRadius: 4,
      },
    },
    dataLabels: { enabled: false },
    xaxis: {
      categories: fastMovingData.map((item) => item.tradeName),
      labels: {
        style: { fontSize: '12px', colors: '#2C2C49' }
      },
    },
    grid: { show: false },
    colors: ["#0047AB", "#E1D9FF", "#B829F4", "#DCE3F2", "#00C49F"],
  };

  const horizontalChartSeries = [
    {
      data: fastMovingData.map((item) => item.total),
    },
  ];

  if (loading && !stockLevelData.length && !fastMovingData.length) {
    return <Box p={3}>Loading charts...</Box>;
  }

  return (
    <Box display="flex" gap={4} p={3} sx={{ flexWrap: 'nowrap', alignItems: 'flex-start' }}>
      {/* Stock Level Chart - Left */}
      <Box
        sx={{
          backgroundColor: "#fff",
          borderRadius: 2,
          boxShadow: 2,
          padding: 3,
          flex: '1 1 60%',
          minWidth: 500,
        }}
      >
        <Box display="flex" justifyContent="space-between" mb={2}>
          <Typography variant="subtitle1" fontWeight={600}>
            Stock Level
          </Typography>
        </Box>
        <Chart options={barChartOptions} series={barChartSeries} type="bar" height={300} />
      </Box>

      {/* Fast Moving Product Chart - Right */}
      <Box
        sx={{
          backgroundColor: "#fff",
          borderRadius: 2,
          boxShadow: 2,
          padding: 3,
          flex: '1 1 40%',
          minWidth: 400,
        }}
      >
        <Box display="flex" justifyContent="space-between" mb={2}>
          <Typography variant="subtitle1" fontWeight={600}>
            Fast Moving Product
          </Typography>
          <Select
            value={selectedYear}
            onChange={handleYearChange}
            size="small"
            variant="outlined"
          >
            {[ "2024", "2025"].map((year) => (
              <MenuItem key={year} value={year}>
                {year}
              </MenuItem>
            ))}
          </Select>
        </Box>
        <Chart
          options={horizontalChartOptions}
          series={horizontalChartSeries}
          type="bar"
          height={280}
        />
      </Box>
    </Box>
  );
};

export default StockDashboard;